import React from 'react'
import createSvgIcon from './utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M3.5 5a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V6a1 1 0 00-1-1h-10zM17.5 5a1 1 0 00-1 1v12a1 1 0 001 1h3a1 1 0 001-1V6a1 1 0 00-1-1h-3z" />
  </React.Fragment>,
  'ViewLeftFocus',
)
